import editorAction from "../actions/editorAction";
import { useTreeStateContext } from "../contexts/TreeContext";

// Hook for change state of click if previous state is not the same
function useClick() {
    const { setPressDown } = editorAction();

    const { pressDown  } = useTreeStateContext();
    
    const onClickDown = () => {
        if(pressDown == true) return false;
        setPressDown(true);
        return true;
    }

    const onClickUp = () => {
        if(pressDown == false) return false;
        setPressDown(false);
        return true;
    }

    return { onClickDown, onClickUp, pressDown};
}

export default useClick;